import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITagDTO, ITagUsageDTO } from '@modeso/types__aumico-lib-companies-be';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/tags.actions';
import { AumicoTagsService } from '../services/tags.service';

/** REV-22155 — start action → service (HTTP) → success / failure action. */
@Injectable()
export class TagsEffects {
    constructor(private actions$: Actions, private service: AumicoTagsService) {}

    getTags$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getTags),
            mergeMap(() =>
                this.service.getTags().pipe(
                    map((tags: ITagDTO[]) => fromActions.onGettingTagsSuccessfully({ payload: tags })),
                    catchError((error: HttpErrorResponse) => of(fromActions.onGettingTagsFailed({ payload: error }))),
                ),
            ),
        ),
    );

    createTag$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.createTag),
            mergeMap(({ name }) =>
                this.service.createTag(name).pipe(
                    map((tag: ITagDTO) => fromActions.onCreateTagSuccessfully({ payload: tag })),
                    catchError((error: HttpErrorResponse) => of(fromActions.onCreateTagFailed({ payload: error }))),
                ),
            ),
        ),
    );

    getTagUsage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getTagUsage),
            mergeMap(({ id }) =>
                this.service.getTagUsage(id).pipe(
                    map((usage: ITagUsageDTO) => fromActions.onGettingTagUsageSuccessfully({ id, payload: usage })),
                    catchError((error: HttpErrorResponse) =>
                        of(fromActions.onGettingTagUsageFailed({ payload: error })),
                    ),
                ),
            ),
        ),
    );

    deleteTag$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.deleteTag),
            mergeMap(({ id }) =>
                this.service.deleteTag(id).pipe(
                    // 204 without a body — the id comes from the action.
                    map(() => fromActions.onDeleteTagSuccessfully({ id })),
                    catchError((error: HttpErrorResponse) => of(fromActions.onDeleteTagFailed({ payload: error }))),
                ),
            ),
        ),
    );
}
